// Builds CreateBookingParams for a one-off "Book Flex" booking made from a slot's dimmed
// (pre-start) intermediary occurrences. A flex booking is a single adhoc booking ("Flexible")
// with the slot's room/time/duration/member, on the chosen intermediary date. Not linked to the
// slot (deliberate). Co-located with RepeatSetupScreen — its only consumer — so it can reuse the
// flow's calculateEndTime rather than adding another copy.
import { calculateEndTime } from "./utils";
import type { CreateBookingParams } from "@/api/bookingApi";

export interface FlexBookingArgs {
  locationId: string;
  roomId: string;
  memberId: string;
  time: string; // HHmm
  durationMinutes: number;
  date: Date;
}

export function buildFlexBookingParams(args: FlexBookingArgs): CreateBookingParams {
  return {
    locationId: args.locationId,
    roomId: args.roomId,
    memberId: args.memberId,
    date: args.date,
    startTime: args.time,
    endTime: calculateEndTime(args.time, args.durationMinutes),
    type: "adhoc",
    hasBuffers: true,
    isRecurring: false,
  };
}
